(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bd-cart-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bd-cart-delivery')) {
  customElements.define('bd-cart-delivery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.address = this.querySelector('[data-address]');
      this.suburb = this.querySelector('[data-suburb]');
      this.postcode = this.querySelector('[data-postcode]');
      this.state = this.querySelector('[data-state]');
      this.button = this.querySelector('[data-estimate]');
      this.status = this.querySelector('[role="status"]');
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      this.button.addEventListener('click', () => this.estimate(), options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Enter' && event.target.matches('input, select')) {
          event.preventDefault();
          if (!this.button.disabled) this.estimate();
        }
      }, options);
      this.addEventListener('input', () => this.invalidate(), options);
      this.addEventListener('change', () => this.invalidate(), options);
      const cartChanged = () => this.invalidate();
      for (const eventName of ['cart:updated','cart:refresh','cart:change']) document.addEventListener(eventName, cartChanged, options);
      document.addEventListener('click', event => {
        if (event.target.closest('[data-action="increase-quantity"],[data-action="decrease-quantity"],a[href*="/cart/change"],button[name="update"]')) this.invalidate();
      }, {...options,capture:true});
      document.addEventListener('input', event => {
        if (event.target.matches('[data-line],input[name="updates[]"],input[name="quantity"]')) this.invalidate();
      }, {...options,capture:true});
      const cartTable = this.closest('section')?.querySelector('.line-item-table');
      if (cartTable) {
        this.cartObserver = new MutationObserver(cartChanged);
        this.cartObserver.observe(cartTable,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['value','data-quantity','data-current-value']});
      }
      try { sessionStorage.removeItem('bd-cart-delivery-address'); } catch {}

    }
    disconnectedCallback() {
      this.cartObserver?.disconnect();
      this.events?.abort();
      this.request?.abort();
      this.ready = false;
    }
    invalidate() {
      this.request?.abort();
      this.request = null;
      this.button.disabled = false;
      this.status.textContent = '';
      this.status.removeAttribute('aria-busy');
      for (const field of [this.address,this.suburb,this.postcode,this.state]) field.removeAttribute('aria-invalid');
    }
    async cartFingerprint(init) {
      const response = await fetch(this.dataset.cartUrl.replace(/\/$/,'') + '.js',{...init,cache:'no-store'});
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      return JSON.stringify({items:cart.items.map(item => [item.key,item.quantity,item.final_line_price,item.requires_shipping]),total:cart.total_price,currency:cart.currency});
    }
    async estimate() {
      this.invalidate();
      const address = this.address.value.trim();
      const suburb = this.suburb.value.trim();
      for (const [field,value,message] of [[this.address,address,this.messages.address],[this.suburb,suburb,this.messages.suburb]]) {
        if (!value || !field.checkValidity()) {
          this.status.textContent = message;
          field.setAttribute('aria-invalid','true');
          field.focus();
          return;
        }
      }
      const postcode = this.postcode.value.trim();
      if (!/^[0-9]{4}$/.test(postcode)) {
        this.status.textContent = this.messages.postcode;
        this.postcode.setAttribute('aria-invalid','true');
        this.postcode.focus();
        return;
      }
      if (!this.state.value) {
        this.status.textContent = this.messages.state;
        this.state.setAttribute('aria-invalid','true');
        this.state.focus();
        return;
      }
      this.request?.abort();
      const request = this.request = new AbortController();
      const timeout = setTimeout(() => request.abort(), 25000);
      this.button.disabled = true;
      this.status.textContent = this.messages.loading;
      this.status.setAttribute('aria-busy','true');
      try {
        const parameters = new URLSearchParams({'shipping_address[address1]':address,'shipping_address[city]':suburb,'shipping_address[zip]':postcode,'shipping_address[country]':'Australia','shipping_address[province]':this.state.value});
        const base = this.dataset.cartUrl.replace(/\/$/,'');
        const init = {credentials:'same-origin',signal:request.signal,headers:{Accept:'application/json'}};
        const beforeCart = await this.cartFingerprint(init);
        const prepared = await fetch(`${base}/prepare_shipping_rates.json?${parameters}`, {...init,method:'POST'});
        if (!prepared.ok) throw new Error('prepare');
        let data = null;
        for (let attempt = 0; attempt < 10; attempt++) {
          if (attempt) await new Promise(resolve => setTimeout(resolve,1200));
          if (request.signal.aborted) throw new Error('cancelled');
          const response = await fetch(`${base}/async_shipping_rates.json?${parameters}`,{...init,cache:'no-store'});
          if (!response.ok) throw new Error('rates');
          data = await response.json();
          if (data !== null) break;
        }
        if (!this.isConnected || request !== this.request) return;
        if (!data || !Array.isArray(data.shipping_rates)) throw new Error('missing');
        const afterCart = await this.cartFingerprint(init);
        if (!this.isConnected || request !== this.request) return;
        if (beforeCart !== afterCart) {
          this.status.textContent = this.messages.changed;
          return;
        }
        this.status.replaceChildren();
        if (!data.shipping_rates.length) { this.status.textContent = this.messages.empty; return; }
        const title = document.createElement('strong');
        title.textContent = this.messages.title;
        const list = document.createElement('ul');
        for (const rate of data.shipping_rates) {
          const price = Number(rate.price);
          if (!Number.isFinite(price)) continue;
          const line = document.createElement('li');
          const label = document.createElement('span');
          const amount = document.createElement('strong');
          label.textContent = rate.presentment_name || rate.name;
          amount.textContent = price === 0 ? this.messages.free : new Intl.NumberFormat('en-AU',{style:'currency',currency:rate.currency || this.dataset.currency || 'AUD'}).format(price);
          line.append(label,amount);list.append(line);
        }
        if (!list.children.length) throw new Error('empty');
        this.status.append(title,list);
      } catch {
        if (this.isConnected && request === this.request) this.status.textContent = this.messages.error;
      } finally {
        clearTimeout(timeout);
        if (request === this.request) {
          this.button.disabled = false;
          this.status.removeAttribute('aria-busy');
        }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bd-mobile-cart-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bd-mobile-cart-bar')) {
  customElements.define('bd-mobile-cart-bar', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('[data-section-type="product"]');
      this.form = this.section?.querySelector('form.product-form');
      this.original = this.form?.querySelector('.product-form__add-button');
      if (!this.original) return;
      this.addButton = this.querySelector('[data-bd-cart-add]');
      this.price = this.querySelector('[data-bd-cart-price]');
      this.selection = this.querySelector('[data-bd-cart-selection]');
      this.mobile = matchMedia('(max-width: 740px)');
      this.pending = false;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      this.querySelector('[data-bd-cart-options]').addEventListener('click', () => this.showOptions(), options);
      this.addButton.addEventListener('click', () => {
        if (this.pending || this.original.disabled) return;
        if (!this.form.reportValidity()) { this.showOptions(); return; }
        this.pending = true;
        this.update();
        this.original.click();
        this.schedule();
      }, options);
      this.section.addEventListener('product:added', () => { this.pending = false; this.schedule(); }, options);
      this.section.addEventListener('variant:changed', this.schedule, options);
      this.form.addEventListener('change', this.schedule, options);
      this.form.addEventListener('input', this.schedule, options);
      document.addEventListener('theme:loading:end', () => { this.pending = false; this.schedule(); }, options);
      document.addEventListener('focusin', this.schedule, options);
      document.addEventListener('focusout', this.schedule, options);
      window.addEventListener('scroll', this.schedule, { passive:true, ...options });
      window.addEventListener('resize', this.schedule, options);
      this.mobile.addEventListener('change', this.schedule, options);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.form, { subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled','class','aria-busy'] });
      this.observer.observe(document.documentElement, { attributes:true, attributeFilter:['class'] });
      this.observer.observe(document.body, { attributes:true, attributeFilter:['class'] });
      const cart = document.getElementById('mini-cart');
      if (cart) this.observer.observe(cart, { attributes:true, attributeFilter:['aria-hidden','class'] });
      this.update();
    }
    update() {
      const blocked = document.querySelector('#mini-cart[aria-hidden="false"],.modal[aria-hidden="false"],dialog[open],.rb-nursery-lock,.lock-all,.lock-mobile');
      const editing = document.activeElement?.matches('input:not([type="radio"]):not([type="checkbox"]),textarea,select');
      this.hidden = !this.mobile.matches || this.original.getBoundingClientRect().bottom > 0 || !!blocked || !!editing;
      const label = this.original.textContent.trim();
      if (this.addButton.textContent !== label) this.addButton.textContent = label;
      this.addButton.disabled = this.original.disabled || this.pending;
      this.addButton.setAttribute('aria-busy', String(this.pending));
      const currentPrice = this.form.querySelector('.price-list .price:not(.price--compare)');
      if (currentPrice && this.price.innerHTML !== currentPrice.innerHTML) this.price.innerHTML = currentPrice.innerHTML;
      const selected = Array.from(this.form.querySelectorAll('.product-form__selected-value')).map(item => item.textContent.trim()).filter(Boolean).join(' / ');
      this.selection.textContent = selected;
      this.selection.hidden = !selected;
      const error = this.form.querySelector('.alert--error');
      if (error && error !== this.lastError) { this.lastError = error; this.pending = false; this.showOptions(); }
    }
    showOptions() {
      const target = this.form.querySelector('.product-form__single-selector:not([type="hidden"]),[name="quantity"]') || this.original;
      this.form.scrollIntoView({ behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center' });
      target.focus({ preventScroll:true });
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  function initMenuSizing() {
    const menu = document.querySelector('#mobile-menu.bd-mobile-menu');
    if (!menu || menu.dataset.sizingReady) return;
    menu.dataset.sizingReady = 'true';
    menu.querySelector('.bd-menu-bundle')?.addEventListener('click', () => {
      if (menu.getAttribute('aria-hidden') === 'false') menu.closest('.header__mobile-nav').querySelector('[data-action="toggle-menu"]')?.click();
    });
    const header = menu.closest('.header__inner');
    const size = () => {
      const viewport = window.visualViewport;
      const bottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
      menu.style.setProperty('--bd-menu-height', Math.max(180, bottom - header.getBoundingClientRect().bottom - 10) + 'px');
    };
    new MutationObserver(size).observe(menu, {attributes:true, attributeFilter:['aria-hidden']});
    new ResizeObserver(size).observe(header);
    window.addEventListener('resize',size,{passive:true});
    window.addEventListener('scroll',size,{passive:true});
    window.visualViewport?.addEventListener('resize',size,{passive:true});
    size();
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initMenuSizing); else initMenuSizing();
  document.addEventListener('shopify:section:load',initMenuSizing);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rever-product-videos"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-rb-videos]').forEach(section => {
      if (section.dataset.rbVideosReady) return;
      section.dataset.rbVideosReady = 'true';
      document.querySelectorAll('a[href="#rb-product-videos"]').forEach(link => {
        link.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          const header = document.querySelector('header.header');
          const offset = header ? header.getBoundingClientRect().height + 24 : 24;
          window.scrollTo({top:window.scrollY + section.getBoundingClientRect().top - offset,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        });
      });
      const panels = [...section.querySelectorAll('[data-rb-video-panel]')];
      const buttons = [...section.querySelectorAll('[data-rb-video-select]')];
      const load = panel => panel?.querySelectorAll('iframe[data-rb-video-src]').forEach(frame => {if (!frame.getAttribute('src')) frame.src = frame.dataset.rbVideoSrc;});
      const choose = id => {
        panels.forEach(panel => {
          const active = panel.dataset.rbVideoPanel === id;
          if (!active) {
            panel.querySelectorAll('video').forEach(video => video.pause());
            panel.querySelectorAll('iframe[src]').forEach(frame => frame.removeAttribute('src'));
          }
          panel.hidden = !active;
          if (active) load(panel);
        });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.rbVideoSelect === id)));
      };
      buttons.forEach(button => button.addEventListener('click', () => choose(button.dataset.rbVideoSelect)));
      const navigation = section.querySelector('[data-rb-video-navigation]');
      if (navigation) navigation.hidden = false;
      section.querySelectorAll('[data-rb-video-scroll]').forEach(button => button.addEventListener('click', () => {
        const rail = section.querySelector('.rb-videos-rail');
        rail.scrollBy({left:Number(button.dataset.rbVideoScroll) * Math.max(rail.clientWidth * .8,156),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }));
      const observer = new IntersectionObserver(entries => {if(entries.some(entry => entry.isIntersecting)){load(panels.find(panel=>!panel.hidden));observer.disconnect();}}, {rootMargin:'150px'});
      observer.observe(section);
    });
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initialise());else initialise();
  document.addEventListener('shopify:section:load',event=>initialise(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
